import moment from 'moment';

// 휴대포번호 입력 시 하이픈 추가
export const phoneNumberAddHypen = (phone: string) => {
  if (!phone) return '';
  return phone
    .replace(/[^0-9]/g, '')
    .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, '$1-$2-$3')
    .replace(/(\-{1,2})$/g, '');
};

// 휴대포번호 형식 검증
export const phoneNumberFormatCheck = (phone: string) => {
  if (!phone) return '';
  const regExp_ctn = /^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})([0-9]{3,4})([0-9]{4})$/;
  return regExp_ctn.test(phone);
};

// 데이터 가공 시 단위 문자 제거 (시,분,km,m 등)
export const onlyNumberInput = (value: string) => {
  const regex = /[^0-9]/g;
  return value.replace(regex, '');
};

// 거리 단위 값 반환
export const formatValueToNumber = (value: string) => {
  const str = value;
  if (str.includes('km')) {
    const num = Number(str.split('km')[0]);
    return (num * 1000).toString();
  } else if (str.includes('m')) {
    const num = Number(str.split('m')[0]);
    return num;
  } else {
    return str;
  }
};

// 기본 프로필 이미지 주소 반환
export const getProfileImg = (gender: '남자' | '여자' | undefined) => {
  return `https://wesop.s3.ap-northeast-2.amazonaws.com/shopsol/profile_${gender === '남자' ? 'm' : 'w'}.png`;
};

// 날짜객체 받아서 나이 값 리턴
export const getAge = (date: Date) => {
  if (moment(date).isValid()) {
    let age = moment().year() - moment(date).year();
    const justBirthDay = moment(date).year(new Date().getFullYear());
    if (!moment(date).isBefore(justBirthDay)) {
      age += 1;
    }
    return age;
  }
  return 0;
};

// 날짜객체 받아서 요일 값 리턴
export const getDayWithKorean = (date: Date) => {
  let day = moment(date).weekday();
  if (day === 0) return '일';
  if (day === 1) return '월';
  if (day === 2) return '화';
  if (day === 3) return '수';
  if (day === 4) return '목';
  if (day === 5) return '금';
  return '토';
};
// 요일 value 받아서 요일 리턴
export const getChangeToKorean = (day: string) => {
  if (day === '0') return '일';
  if (day === '1') return '월';
  if (day === '2') return '화';
  if (day === '3') return '수';
  if (day === '4') return '목';
  if (day === '5') return '금';
  if (day === '6') return '토';
  return '';
};

// 금액 문자열 콤마 추가
export const addComma = (num: string) => {
  if (num) {
    // 'addComma', num)
    var regexp = /\B(?=(\d{3})+(?!\d))/g;
    return num.toString().replace(regexp, ',');
  } else {
    return num;
  }
};

// 금액 문자열 콤마 추가 0000 => 00시00분
export const formatTimeValueToText = (sum: number | string | undefined) => {
  if (sum == undefined || sum == null || sum == 0) return '0';
  let hour = Math.floor(Number(sum) / 60);
  let min = Math.floor(Number(sum) % 60);
  let time = hour + '시간' + min + '분';
  if (hour <= 0) {
    time = min + '분';
  }
  if (min <= 0) {
    time = hour + '시간';
  }
  return time;
};

// 00:00 -> 0시0분
export const formatTimeDigitalToKorean = (time: string) => {
  if (time.length >= 5) {
    const hour = time.split(':')[0];
    const min = time.split(':')[1];
    return `${hour}시${min}분`;
  }
  return '';
};

// number -> 0시0분
export const formatTimeNumberToKorean = (time: number) => {
  if (isNaN(time) || time === 0) return `0시간`;
  const hour = Math.floor(time / 60);
  const min = Math.floor(time % 60);
  let hourText = '';
  let minText = '';
  if (hour > 0) {
    hourText = `${hour}시간`;
    if (min > 0) minText = ` ${min}분`;
  } else {
    if (min > 0) minText = `${min}분`;
  }
  return hourText + minText;
};

// 0시간0분 -> 0
export const formatKoreanTimeToMinuteValue = (time: string | number) => {
  let value = typeof time === 'number' ? time.toString() : time;
  if ((!value.includes('시') && !value.includes('분')) || !time) return 0;
  let hour = 0;
  let min = 0;
  if (value.includes('시') && value.includes('분')) {
    hour = Number(value.split('시간')[0]) * 60;
    min = Number(onlyNumberInput(value.split('시')[1]));
  } else {
    if (value.includes('시')) {
      hour = Number(value.split('시간')[0]) * 60;
    } else {
      min = Number(value.split('분')[0]);
    }
  }
  return hour + min;
};

// 0(분값) -> 0시간 0분
export const formatNumberValueToKoreanTime = (min: number) => {
  if (min === 0 || isNaN(min)) return 0;
  let hourText = '';
  let minText = '';
  if (min / 60 > 0) {
    hourText = Math.floor(min / 60) + '시간';
  }
  if (min % 60 > 0) {
    minText = `${min % 60}${hourText === '' ? '분' : ' 분'}`;
  }
  return hourText + minText;
};

// 00시00분 -> Date
export const formatKoreanTimeToDateObj = (time: string) => {
  if (typeof time !== 'string' || !time.includes('시') || !time.includes('분') || !time) return new Date();
  const hour = time.split('시')[0];
  const min = time.split('시')[1].slice(0, 2);
  return new Date(new Date().setHours(Number(hour), Number(min), 0, 0));
};

// 00:00 ~ 00:00 -> 0분
export const scheduleToMinValue = (start: string, end: string) => {
  if (typeof start !== 'string' || start.length === 0 || !start.includes(':')) return 0;
  if (typeof end !== 'string' || end.length === 0 || !end.includes(':')) return 0;
  let workTimeOfDay = 0;
  const startTimeToMin = Number(start.split(':')[0]) * 60 + Number(start.split(':')[1]);
  const endTimeToMin = Number(end.split(':')[0]) * 60 + Number(end.split(':')[1]);
  let workTime = 0;
  if (startTimeToMin < endTimeToMin) {
    workTime = endTimeToMin - startTimeToMin;
  }
  if (startTimeToMin > endTimeToMin) {
    workTime = 1440 - startTimeToMin + endTimeToMin;
  }
  workTimeOfDay = workTime;
  return workTime;
};

// 0 (초) -> 00:00
export const milisecondToKoreanTime = (ms: number) => {
  if (ms <= 0) return '00:00';
  let hour: number | string = Math.floor(ms / 60);
  if (hour < 10) hour = '0' + hour;
  let min: number | string = Math.floor(ms % 60);
  if (min < 10) min = '0' + min;
  return `${hour}:${min}`;
};

// 00시00분 -> 00:00
export const removeKoreanWordTime = (time: string): string => {
  if (!(time.length > 0)) return '00:00';
  return time.replace('시', ':').replace('분', '');
};
